import PropTypes from 'prop-types'

/*
EXAMPLE:

{
  "id": "1",
}

*/

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,

  willRemove: PropTypes.bool,
})
